module.exports = __webpack_public_path__ + "static/media/linkedInLogo.afd84371.svg";